// Ionic Angular
import { Component, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "tidy-card-input",
    encapsulation: ViewEncapsulation.None,
    template: `
  <div class="tidy-container">
    <div class="tidy-item icon-align">
        <ng-content select="[item-left]"></ng-content>
    </div>
    <div class="tidy-item tidy-input tidy-form big-text">
      <ng-content select="[item-right]"></ng-content>
      <ng-content select="[camera-icon]"></ng-content>
    </div>
  </div>
  `,
    standalone: false
})
export class TidyCardInput {}
